var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 28 28"}},[_c('circle',{attrs:{"id":"Ellipse_633","data-name":"Ellipse 633","cx":"14","cy":"14","r":"14","fill":"#f0ac19"}})])}
var staticRenderFns = []

export { render, staticRenderFns }